import CompanyList from "./component";

export default CompanyList;
